import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-400 border border-secondary-500/20 mb-3">
            <i className="ri-mail-send-line mr-1"></i>联络通道
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {contactInfo.title}
          </h2>
          <p className="mt-2 text-sm text-foreground-500">{contactInfo.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {contactInfo.items.map((item) => (
            <div
              key={item.label}
              className="p-5 rounded-xl bg-background-50 border border-background-200/50 text-center hover:border-primary-500/20 transition-colors duration-200"
            >
              <span className="inline-flex w-12 h-12 rounded-full bg-primary-500/10 items-center justify-center mb-3">
                <i className={`${item.icon} text-xl text-primary-400`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">{item.label}</h3>
              <p className="text-xs text-foreground-500">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}